import VistaMonitoreo from "@/views/VistaMonitoreo.vue";

const monitoreo = {
  path: "/app/monitoreo",
  name: "monitoreo",
  component: VistaMonitoreo,
};

export default monitoreo;
